import { Skeleton, Typography } from "antd";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import PieChart from "../charts/Pie";
import useMyQuery from "@/hooks/useMyQuery";
import { formatPercent } from "@/helpers";
import TokenFlows from "./TokenFlows";
import TokenTransfers from "./TokenTransfers";

interface MarketShareData {
  name: string;
  marketShare: number;
}

interface MarketShareResponse {
  success: boolean;
  data: MarketShareData[];
}

export default function Overview() {
  const t = useTranslations("exchange");

  const { data: marketShareResponse, isLoading } = useMyQuery<MarketShareResponse>(
    {
      url: "/v1/holder-info/exchange/statistics/market-share",
      method: "get",
    },
    {
      queryKey: ["market-share"],
      refetchInterval: 15 * 60 * 1000,
    },
  );

  const diversityData = useMemo(() => {
    if (!marketShareResponse?.data) return [];

    return marketShareResponse.data.map(item => ({
      ticker: item.name,
      percentage: Number(formatPercent(item.marketShare)),
    }));
  }, [marketShareResponse]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-8">
      <TokenFlows />
      <TokenTransfers />
      <div className="col-span-1">
        <div className="bg-white rounded-lg border border-[#e5e7eb] p-4">
          <Typography.Title level={5} className="!mb-0">
            {t("Market_share")}
          </Typography.Title>
          <div className="h-[460px]">
            {isLoading ? (
              <Skeleton paragraph={{ rows: 10 }} />
            ) : (
              <PieChart data={diversityData} isLoading={isLoading} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

